import { env } from "@/config/env";

export async function transcribeAudio(
  audioFile: Blob | File,
  language?: string,
): Promise<string> {
  const form = new FormData();
  form.append("file", audioFile);
  form.append("model", "whisper-1");
  form.append("response_format", "text");
  if (language) form.append("language", language);

  const res = await fetch("https://api.openai.com/v1/audio/transcriptions", {
    method: "POST",
    headers: { Authorization: `Bearer ${env.openai.apiKey}` },
    body: form,
  });

  if (!res.ok) {
    throw new Error(`Whisper API error: ${res.status}`);
  }

  return (await res.text()).trim();
}
